<div class="searchConsole" id="searchConsoleDefult5" aria-hidden="true"
  aria-labelledby="searchConsoleDefultLabel5" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-fullscreen">
    <div class="modal-content rounded-0 border-0 st treeSelectorbg">
      <app-advance-header [breadcrumb]="breadCrumb" (valueChange)='getChildValue($event)'></app-advance-header>
      <div class="modal-body vehicle-filter-type" style="height: 100vh;">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 vehicle-content">
            <div class="vehicle-wrapper">
              <img class="img-fluid img-bright" [src]="level3newImages?.l3_actual_name == 'Maxi Van-Ambulance' || level3newImages?.l3_actual_name == 'Maxi Van passenger' || level3newImages?.l3_actual_name == 'Mini Van' ||  level3newImages?.l3_actual_name == 'ICV Buses school' || level3newImages?.l3_actual_name == 'LCV Buses school' ? level3newImages?.l3_image_path : level3DataImages" />
              <div class="ellipse"></div>
              <img class="img-fluid img-mirror" [src]="level3newImages?.l3_actual_name == 'Maxi Van-Ambulance' || level3newImages?.l3_actual_name == 'Maxi Van passenger' || level3newImages?.l3_actual_name == 'Mini Van' ||  level3newImages?.l3_actual_name == 'ICV Buses school' || level3newImages?.l3_actual_name == 'LCV Buses school'? level3newImages?.l3_image_path : level3DataImages" />
              <div class="filter-type filter-type-1" *ngIf="smartFilter[0]?.data && smartFilter?.length>0 && smartFilter[0]?.data?.length>0 ">
                <div class="filter-item-details">
                  <div class="filter-item-details-title">
                    <img alt="" [src]='environment1 + "assets/images/advancesearch/list-item-icon1.png"'
                      loading="lazy" />
                    <span *ngIf="smartFilter?.length > 0">{{smartFilter[0] | changelebels}}</span>
                    <span class="ms-auto">1/{{smartFilter?.length}}</span>
                  </div>
                  <div class="filter-item-details-list mt-3 filterclick">
                    <span *ngFor="let item of smartFilter[0]?.data | keyvalue"
                      (click)="filterClick(smartFilter[0]?.label,item.value[smartFilter[0]?.label],4)"
                      [ngClass]="{'active': json[smartFilter[0]?.label] === item.value[smartFilter[0]?.label]}">
                      {{item.value[smartFilter[0]?.label]}}
                    </span>
                  </div>
                </div>
              </div>


              <div class="filter-type filter-type-2" *ngIf="smartFilter?.length>1 && smartFilter[1]?.data && smartFilter[1]?.data?.length>0 ">
                <div class="filter-item-details">
                  <div class="filter-item-details-title">
                    <img alt="" [src]='environment1 + "assets/images/advancesearch/SmartFilterFuel.png"' />
                    <span *ngIf="smartFilter?.length > 0">{{smartFilter[1] | changelebels}}</span>
                    <span class="ms-auto">2/{{smartFilter?.length}}</span>
                  </div>
                  <div class="filter-item-details-list mt-3 filterclick">
                    <span *ngFor="let item of smartFilter[1]?.data | keyvalue"
                      (click)="filterClick(smartFilter[1]?.label,item.value[smartFilter[1]?.label],1)"
                      [ngClass]="{'active': json[smartFilter[1]?.label] === item.value[smartFilter[1]?.label]}">
                      {{item.value[smartFilter[1]?.label]}}
                    </span>
                  </div>
                </div>
              </div>

              <div class="filter-type filter-type-3" *ngIf="smartFilter?.length>2 && smartFilter[2]?.data && smartFilter[2]?.data?.length>0 ">
                <div class="filter-item-details">
                  <div class="filter-item-details-title">
                    <img alt="" [src]='environment1 + "assets/images/advancesearch/FIlter_cxlx.png"' loading="lazy" />
                    <span *ngIf="smartFilter?.length > 0">{{smartFilter[2] | changelebels}}</span>
                    <span class="ms-auto">3/{{smartFilter?.length}}</span>
                  </div>
                  <div class="filter-item-details-list mt-3 filterclick">
                    <span *ngFor="let item of smartFilter[2]?.data | keyvalue"
                      (click)="filterClick(smartFilter[2]?.label,item.value[smartFilter[2]?.label],2)"
                      [ngClass]="{'active': json[smartFilter[2]?.label] === item.value[smartFilter[2]?.label]}">
                      {{item.value[smartFilter[2]?.label]}}
                    </span>
                  </div>
                </div>
              </div>

              <div class="filter-type filter-type-4" *ngIf="smartFilter?.length>3 && smartFilter[3]?.data && smartFilter[3]?.data?.length>0 ">
                <div class="filter-item-details">
                  <div class="filter-item-details-title">
                    <img alt="" [src]='environment1 + "assets/images/advancesearch/Filter_TyreType.png"'
                      loading="lazy" />
                    <span *ngIf="smartFilter?.length > 0">{{smartFilter[3] | changelebels}}</span>
                    <span class="ms-auto">4/{{smartFilter?.length}}</span>
                  </div>
                  <div class="filter-item-details-list mt-3 filterclick">
                    <span *ngFor="let item of smartFilter[3]?.data | keyvalue"
                      (click)="filterClick(smartFilter[3]?.label,item.value[smartFilter[3]?.label],3)"
                      [ngClass]="json[smartFilter[3]?.label]  === item.value[smartFilter[3]?.label] ? 'active' : ''">
                      {{item.value[smartFilter[3]?.label]}}
                    </span>
                  </div>
                </div>
              </div>

              <div class="filter-type filter-type-5" *ngIf="smartFilter?.length>4 && smartFilter[4]?.data && smartFilter[4]?.data?.length>0 ">
                <div class="filter-item-details">
                  <div class="filter-item-details-title">
                    <img alt="" src="../../assets/advancesearch/FeaturePremium.png" />
                    <span *ngIf="smartFilter?.length > 0">{{smartFilter[4] | changelebels}}</span>
                    <span class="ms-auto">5/{{smartFilter?.length}}</span>
                  </div>
                  <div class="filter-item-details-list mt-3 filterclick">
                    <span *ngFor="let item of smartFilter[4]?.data | keyvalue"
                      (click)="filterClick(smartFilter[4]?.label,item.value[smartFilter[4]?.label],5)"
                      [ngClass]="json[smartFilter[4]?.label]  === item.value[smartFilter[4]?.label] ? 'active' : ''">
                      {{item.value[smartFilter[4]?.label]}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="filter-type filter-type-6" *ngIf="smartFilter?.length>5 && smartFilter[5]?.data && smartFilter[5]?.data?.length>0 ">
                <div class="filter-item-details">
                  <div class="filter-item-details-title">
                    <img alt="" src="../../assets/advancesearch/SuspensionType.png" />
                    <span *ngIf="smartFilter?.length > 0">{{smartFilter[5] | changelebels}}</span>
                    <span class="ms-auto">6/{{smartFilter?.length}}</span>
                  </div>
                  <div class="filter-item-details-list mt-3 filterclick">
                    <span *ngFor="let item of smartFilter[5]?.data | keyvalue"
                      (click)="filterClick(smartFilter[5]?.label,item.value[smartFilter[5]?.label],6)"
                      [ngClass]="{'active': json[smartFilter[5]?.label] === item.value[smartFilter[5]?.label]}">
                      {{item.value[smartFilter[5]?.label]}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- mobile view filter -->
          <!-- mobile view filter -->
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 type-option-filter d-md-none">
            <ul class="nav nav-pills  mb-3" id="type-tab" role="tablist">
              <li class="nav-item   " *ngIf="smartFilter[0]?.data && smartFilter[0]?.data?.length>0 " [ngClass]="{'done': SmartFilterFuel}"
                id="pills-t1-tab" data-bs-toggle="pill" data-bs-target="#pills-t1" type="button" role="tab"
                aria-controls="pills-t1" aria-selected="true">
                <button class="nav-link " (click)="MobileFilter1()">
                  <img alt="" *ngIf="!SmartFilterFuel"
                    [src]='environment1 + "assets/images/advancesearch/list-item-icon1.png"' class="img-fluid " />
                  <img alt="" *ngIf="SmartFilterFuel"
                    [src]='environment1 + "assets/images/advancesearch/list-item-icon5.png"' class="img-fluid" />
                </button>
              </li>
              <li class="nav-item " *ngIf="smartFilter[1]?.data && smartFilter[1]?.data?.length>0  " [ngClass]="{'done': SmartFilterDeck}"
                id="pills-t2-tab" data-bs-toggle="pill" data-bs-target="#pills-t2" type="button" role="tab"
                aria-controls="pills-t2" aria-selected="false">
                <button class="nav-link" (click)="MobileFilter2()">
                  <img alt="" *ngIf="!SmartFilterDeck"
                    [src]='environment1 + "assets/images/advancesearch/SmartFilterFuel.png"' class="img-fluid " />
                  <img alt="" *ngIf="SmartFilterDeck"
                    [src]='environment1 + "assets/images/advancesearch/list-item-icon5.png"' class="img-fluid " />
                </button>
              </li>
              <!-- <li class="nav-item" id="pills-t3-tab" data-bs-toggle="pill" data-bs-target="#pills-t3" type="button" role="tab" aria-controls="pills-t3" aria-selected="false">
                <button class="nav-link" >
                  <img alt="" *ngIf="!SmartFIlterCabin" src="../../assets/advancesearch/Filter_TyreType.png" class="img-fluid type-filter-pending"/>
                  <img alt=""  *ngIf="SmartFIlterCabin" src="../../assets/advancesearch/list-item-icon5.png" class="img-fluid type-filter-done"/>
                </button>
              </li> -->
              <li class="nav-item" *ngIf="smartFilter[2]?.data && smartFilter[2]?.data?.length>0 " [ngClass]="{'done': SmartFIlterCabin}"
                id="pills-t3-tab" data-bs-toggle="pill" data-bs-target="#pills-t3" type="button" role="tab"
                aria-controls="pills-t3" aria-selected="false">
                <button class="nav-link" (click)="MobileFilter3()">
                  <img alt="" *ngIf="!SmartFIlterCabin"
                    [src]='environment1 + "assets/images/advancesearch/Filter_TyreType.png"' class="img-fluid " />
                  <img alt="" *ngIf="SmartFIlterCabin"
                    [src]='environment1 + "assets/images/advancesearch/list-item-icon5.png"' class="img-fluid " />
                </button>
              </li>
              <li class="nav-item" *ngIf="smartFilter[3]?.data && smartFilter[3]?.data?.length>0 " [ngClass]="{'done': SmartFilter}" id="pills-t4-tab"
                data-bs-toggle="pill" data-bs-target="#pills-t4" type="button" role="tab" aria-controls="pills-t4"
                aria-selected="false">
                <button class="nav-link" (click)="MobileFilter4()">
                  <img alt="" *ngIf="!SmartFilter" [src]='environment1 + "assets/images/advancesearch/FIlter_cxlx.png"'
                    class="img-fluid " />
                  <img alt="" *ngIf="SmartFilter"
                    [src]='environment1 + "assets/images/advancesearch/list-item-icon5.png"' class="img-fluid " />
                </button>
              </li>
            </ul>
            <div class="tab-content" id="pills-tabContent">
              <div *ngIf="smartFilter?.length>0 && MobileFilterFirst && smartFilter[0]?.data ">
                <div class="tab-pane  show active" id="pills-t1" role="tabpanel" aria-labelledby="pills-t1-tab"
                  tabindex="0">
                  <div class="filter-item-details">
                    <div class="filter-item-details-title">
                      <!-- {{changeLable(smartFilter[0])}} -->
                      <span *ngIf="smartFilter?.length > 0">{{smartFilter[0] | changelebels}}</span>
                      <span class="ms-auto">1/4</span>
                    </div>
                    <div class="filter-item-details-list mt-3 filterclick">
                      <span *ngFor="let item of smartFilter[0]?.data | keyvalue"
                        (click)="filterClick(smartFilter[0]?.label,item.value[smartFilter[0]?.label],1)"
                        [ngClass]="{'active': json[smartFilter[0]?.label] === item.value[smartFilter[0]?.label]}">
                        {{item.value[smartFilter[0]?.label]}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="smartFilter?.length>1 && MobileFilterSecond  && smartFilter[1]?.data">
                <div class="tab-pane " id="pills-t2" role="tabpanel" aria-labelledby="pills-t2-tab" tabindex="0">
                  <div class="tab-pane  show active" id="pills-t1" role="tabpanel" aria-labelledby="pills-t1-tab"
                    tabindex="0">
                    <div class="filter-item-details">
                      <div class="filter-item-details-title">
                        <span *ngIf="smartFilter?.length > 0">{{smartFilter[1] | changelebels}}</span>
                        <!-- {{changeLable(smartFilter[1])}} -->
                        <span class="ms-auto">2/4</span>
                      </div>
                      <div class="filter-item-details-list mt-3 filterclick">
                        <span *ngFor="let item of smartFilter[1]?.data | keyvalue"
                          (click)="filterClick(smartFilter[1]?.label,item.value[smartFilter[1]?.label],2)"
                          [ngClass]="{'active': json[smartFilter[1]?.label] === item.value[smartFilter[1]?.label]}">
                          <!-- <img alt="" src={{item.value.image_path}} />  -->
                          {{item.value[smartFilter[1]?.label]}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="smartFilter?.length>2 && MobileFilterThird && smartFilter[2]?.data">
                <div class="tab-pane " id="pills-t3" role="tabpanel" aria-labelledby="pills-t3-tab" tabindex="0">
                  <div class="tab-pane  show active" id="pills-t1" role="tabpanel" aria-labelledby="pills-t1-tab"
                    tabindex="0">
                    <div class="filter-item-details">
                      <div class="filter-item-details-title">
                        <!-- {{changeLable(smartFilter[2])}} -->
                        <span *ngIf="smartFilter?.length > 0">{{smartFilter[2] | changelebels}}</span>
                        <span class="ms-auto">3/4</span>
                      </div>
                      <div class="filter-item-details-list mt-3 filterclick">
                        <span *ngFor="let item of smartFilter[2]?.data | keyvalue"
                          (click)="filterClick(smartFilter[2]?.label,item.value[smartFilter[2]?.label],3)"
                          [ngClass]="{'active': json[smartFilter[2]?.label] === item.value[smartFilter[2]?.label]}">
                          <!-- <img alt="" src={{item.value.image_path}} />  -->
                          {{item.value[smartFilter[2]?.label]}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="smartFilter?.length>3 && MobileFilterFourth  && smartFilter[3]?.data">
                <div class="tab-pane " id="pills-t4" role="tabpanel" aria-labelledby="pills-t4-tab" tabindex="0">
                  <div class="tab-pane  show active" id="pills-t1" role="tabpanel" aria-labelledby="pills-t1-tab"
                    tabindex="0">
                    <div class="filter-item-details">
                      <div class="filter-item-details-title">
                        <span *ngIf="smartFilter?.length > 0">{{smartFilter[3] | changelebels}}</span>
                        <!-- {{changeLable(smartFilter[3])}} -->
                        <span class="ms-auto">4/4</span>
                      </div>
                      <div class="filter-item-details-list mt-3 filterclick">
                        <span *ngFor="let item of smartFilter[3]?.data | keyvalue"
                          (click)="filterClick(smartFilter[3]?.label,item.value[smartFilter[3]?.label],4)"
                          [ngClass]="{'active': json[smartFilter[3]?.label] === item.value[smartFilter[3]?.label]}">
                          <!-- <img alt="" src={{item.value.image_path}} />  -->
                          {{item.value[smartFilter[3]?.label]}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12  text-center">
            <button type="button" class="btn btn-primary btn-grad-primary continue-next-btn"
              data-bs-target="#searchConsoleDefult6"
              (click)="getProductListData()">Continue</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div *ngIf="productlistdata">
    <app-advanceproductlist [productlistdata]="productlistdata" [productlistdataLength]="productlistdataLength" [TotalCount_List]="TotalCount_List" [breadCrumb]="breadCrumb" [TotalFIlters]="TotalFIlters" [smartFilter]="smartFilter" [json]="json" [productDetailsData]="productDetailsData"></app-advanceproductlist>
</div> -->
